import { render, staticRenderFns } from "./huovGuestWhap.vue?vue&type=template&id=1d4ffa50"
import script from "./huovGuestWhap.vue?vue&type=script&lang=js"
export * from "./huovGuestWhap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports